'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Yandex API config
 */
var apiConfig = exports.apiConfig = {
  host: 'api-maps.yandex.ru',
  version: '2.1'
};